export const FormFactoryOptions = {
  grid: {
    mainGridClassess: 'grid grid-cols-12 gap-2',
    nestedGridClassess: 'grid grid-cols-12 gap-x-4 gap-y-2',
  },
};
